module.exports = __webpack_public_path__ + "fonts/MicrosoftYaHei.acc224be.ttf";